import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const GET_BENUTZER_LISTE_ADMIN = '[BenutzerverwaltungModul] GetBenutzerListeAdmin laden';
export const GET_BENUTZER_LISTE_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] GetBenutzerListeAdmin ausführen';
export const GET_BENUTZER_LISTE_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] GetBenutzerListeAdmin laden erfolgreich';
export const GET_BENUTZER_LISTE_ADMIN_FEHLER = '[BenutzerverwaltungModul] GetBenutzerListeAdmin Ladefehler';
export const GET_BENUTZER_LISTE_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] GetBenutzerListeAdmin nicht ausgeführt (evtl. Offline)';


export class GetBenutzerListeAdminAction implements Action {
    readonly type = GET_BENUTZER_LISTE_ADMIN;
        constructor(public optPayload: any = null) {}
    }
export class GetBenutzerListeAdminAusfuehrenAction implements Action {
    readonly type = GET_BENUTZER_LISTE_ADMIN_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetBenutzerListeAdminErfolgreichAction implements Action {
    readonly type = GET_BENUTZER_LISTE_ADMIN_ERFOLGREICH;
        constructor(public payload: Array<api.Benutzer>, public optPayload: any = null) {}
    }
export class GetBenutzerListeAdminFehlerAction implements Action {
    readonly type = GET_BENUTZER_LISTE_ADMIN_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetBenutzerListeAdminNichtAusgefuehrtAction implements Action {
    readonly type = GET_BENUTZER_LISTE_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungQueryBenutzerListeAdminActions =
    GetBenutzerListeAdminAction
    | GetBenutzerListeAdminAusfuehrenAction
    | GetBenutzerListeAdminErfolgreichAction
    | GetBenutzerListeAdminFehlerAction
    | GetBenutzerListeAdminNichtAusgefuehrtAction
    ;
